import { XMarkIcon } from '@heroicons/react/16/solid';
import React from 'react';

export default function MoreInfoNew({ activeEpisode, podcast, isDark, showMenu, onClose }) {

    const bgColor = () => isDark ? " bg-[#1F1F21] " : " bg-white "
    const textColor = () => isDark ? " text-gray-200 " : " text-black "
    const textColorLight = () => isDark ? " text-gray-300 " : " text-gray-800 "
    const buttons = () => isDark ? "#B2B9C4" : "black"

    return (
        <div className={bgColor() + `z-10 absolute h-full w-full top-0 left-0 overflow-y-scroll overflow-x-hidden transition-opacity duration-500 p-4 rounded-md ` + (showMenu ? 'opacity-95 pointer-events-auto' : 'opacity-0 pointer-events-none')} >
            <div className={'relative' + textColor()}>
                <div className='cursor-pointer text-base absolute right-2' onClick={onClose}>
                    <XMarkIcon color={buttons()} className='w-6 h-6' />
                </div>
                <div className='text-md font-bold'>{activeEpisode.title}</div>
                <div className='text-sm font-semibold'>{podcast.title}</div>
                <div className={'text-sm font-normal mt-2' + textColorLight()} dangerouslySetInnerHTML={{ __html: activeEpisode.contentSnippet }}></div>
            </div>
        </div>
    )
}


